import React from 'react';
import { BookOpen, MessageCircle, Mic, Headphones, Globe, Plane, Edit3, Book, PenTool, MessageSquare, Puzzle, TrendingUp, RefreshCw } from 'lucide-react';
const modules = [{
  name: 'Gramática',
  icon: BookOpen,
  color: 'text-green-500'
}, {
  name: 'Vocabulario',
  icon: MessageCircle,
  color: 'text-red-500'
}, {
  name: 'Conversación',
  icon: MessageSquare,
  color: 'text-blue-500'
}, {
  name: 'Pronunciación',
  icon: Mic,
  color: 'text-orange-500'
}, {
  name: 'Escucha',
  icon: Headphones,
  color: 'text-green-400'
}, {
  name: 'Cultura',
  icon: Globe,
  color: 'text-blue-600'
}, {
  name: 'Viajes',
  icon: Plane,
  color: 'text-red-600'
}, {
  name: 'Ejercicios',
  icon: Edit3,
  color: 'text-purple-500'
}, {
  name: 'Lectura',
  icon: Book,
  color: 'text-orange-400'
}, {
  name: 'Escritura',
  icon: PenTool,
  color: 'text-blue-400'
}, {
  name: 'Expresiones',
  icon: MessageCircle,
  color: 'text-purple-400'
}, {
  name: 'Juegos',
  icon: Puzzle,
  color: 'text-green-600'
}, {
  name: 'Niveles',
  icon: TrendingUp,
  color: 'text-blue-500'
}, {
  name: 'Repasos',
  icon: RefreshCw,
  color: 'text-orange-500'
}];
export function WhatsIncluded() {
  return <section className="py-20 px-4 max-w-5xl mx-auto" data-id="element-290">
      <div className="text-center mb-12" data-id="element-291">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-292">
          ¿Qué incluye el Megapack?
        </h2>
        <p className="text-xl text-brand-gold" data-id="element-293">
          Todo lo que necesitas para enseñar o aprender
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-294">
        {modules.map((mod, i) => {
        const Icon = mod.icon;
        return <div key={i} className="glass-card p-4 rounded-xl flex flex-col items-center text-center hover:bg-white/5 transition-colors" data-id="element-295">
              <div className="bg-brand-dark p-3 rounded-full mb-3 border border-white/10" data-id="element-296">
                <Icon className={`w-6 h-6 ${mod.color}`} data-id="element-297" />
              </div>
              <span className="text-white font-medium" data-id="element-298">{mod.name}</span>
            </div>;
      })}
      </div>
    </section>;
}